import React, { Fragment } from 'react'
import { useDispatch } from 'react-redux'
import { host } from '../../configuraciones';
import ModalMensajeComponent from './ModalMensajeComponent';
import GetAppIcon from '@mui/icons-material/GetApp';
import { IconButton } from '@mui/material';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../redux/AppDucks';

function BotonDescargarSolicitudComponent(props) {
    const dispatch = useDispatch()
    const {nameTabla, idSolicitud, nameFK, user} = props 
    
    const [openModal, setOpenModal] = React.useState(false)
    const downloadSolicitud = async () => {
        if(nameTabla !== null && nameTabla !== undefined){
            await dispatch(actualizarLoadingApp_true())
            const fileFetch = await fetch(host + `FC_01/servirDocumentos/nameTabla=${nameTabla}&nameFK=${nameFK}&idSolicitud=${idSolicitud}&user=${user}`,{
                method: 'GET',
                headers:{
                    'authorization':localStorage.getItem('user'),
                    'refresh-authorization': localStorage.getItem('refreshToken'),
                    'Content-Type': 'application/json'
                },
            })
            await dispatch(actualizarLoadingApp_false())
            if(fileFetch.status != 404){
                const blob = await fileFetch.blob();
                const url = window.URL.createObjectURL(new Blob([blob]), { type: 'application/zip' });
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${nameTabla}.zip`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }else {
                setOpenModal(true)
            }
        }
    }

    return (
        <Fragment>
            {/* <button onClick={() => downloadSolicitud()} className='btn btn-outline-success'>Descargar</button> */}
            <IconButton onClick={() => downloadSolicitud()}>
                <GetAppIcon sx={{ color: '#c88b3e'}}></GetAppIcon>
            </IconButton>
            
            {
                openModal && 
                <ModalMensajeComponent setOpenModal={{setOpenModal}} titleModal={'Error'} bodyModal={'No hay archivos adjuntos'}></ModalMensajeComponent>
            }
        </Fragment>
    )
}

export default BotonDescargarSolicitudComponent